var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgExtension(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7535_150252)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.14286 1.81798C5.14286 2.42139 4.66238 2.91054 4.06968 2.91054H2.28571C1.29949 2.91054 0.5 3.72448 0.5 4.72852V7.30764C0.5 7.49679 0.671347 7.63729 0.857143 7.63729H1.57143C2.55765 7.63729 3.35714 8.45123 3.35714 9.45527C3.35714 10.4593 2.55765 11.2733 1.57143 11.2733H0.857143C0.671348 11.2733 0.5 11.4138 0.5 11.6029V14.182C0.5 15.1861 1.29949 16 2.28571 16H4.81763C5.00427 16 5.14286 15.8246 5.14286 15.6346V14.9074C5.14286 13.9034 5.94235 13.0895 6.92857 13.0895C7.91479 13.0895 8.71429 13.9034 8.71429 14.9074V15.6346C8.71429 15.8246 8.85287 16 9.03952 16H11.5714C12.5577 16 13.3571 15.1861 13.3571 14.182V11.637C13.3571 11.4362 13.517 11.2734 13.7143 11.2734C14.7005 11.2734 15.5 10.4595 15.5 9.45541C15.5 8.45137 14.7005 7.63743 13.7143 7.63743C13.517 7.63743 13.3571 7.47464 13.3571 7.27384V4.72852C13.3571 3.72448 12.5577 2.91054 11.5714 2.91054H9.78746C9.19476 2.91054 8.71429 2.42139 8.71429 1.81798C8.71429 0.813937 7.91479 0 6.92857 0C5.94235 0 5.14286 0.813938 5.14286 1.81798Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7535_150252"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExtension);
export default __webpack_public_path__ + "static/media/extension.818464b719e5e8722a545d441bcb426e.svg";
export { ForwardRef as ReactComponent };